app.service('paymentView',function(orderConfig, paymentBox, validate) {
	var $self, $form;
	var config;

	function getElements() {
		$self = $('#payment-content');
		$form = $('form:eq(0)');
		config = orderConfig.getData();
	}

	function setEvents() {
		$('.js-payment-next').on('click', function() {
			if ($form.valid()) {
				if($('input[name=paymentType]:checked').length){            //walidacja radio jest koło guzika dalej i musiała by być w starym kodzie ścieżki, wybrałem najmniejsze zło aby łatwiej to kiedyś posprzątać jak płatność k4 będzie miała redesign i niezaznaczenie radio będziemy pokazywać koło radio jak mobilna
					formActionNext(); // wywołanie funkcji globalnej
				}else{
					$('.order-navigation').addClass('error error-payment');
				}
			}
		});
		$('.js-e-payment-bank').on('click', function() {
			setEPaymentBank($(this).data('id'), $(this).data('name'), $(this)); // wywołanie funkcji globalnej
		});
	}

	function init() {
		getElements();
		setEvents();
		paymentBox.init();

	}

	return {
		init
	};
});
